module.exports = __webpack_public_path__ + "assets/fonts/Guroo-Producer.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/guroo-producer/fonts/Guroo-Producer.woff
 ** module id = 1109
 ** module chunks = 0
 **/